import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.GET_PREFERRED_COMMUNICATIONS_REQUEST:
      return {
        ...state,
        data: null,
        result: null,
        isProgress: true,
      };
    case homeConstants.GET_PREFERRED_COMMUNICATIONS_SUCCESS:
      return {
        data: action.response.data,
        result: action.response,
        isProgress: false,
      };
    case homeConstants.GET_PREFERRED_COMMUNICATIONS_FAILURE:
      return {
        data: null,
        result: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: null,
        result: null,
      };
    default:
      return state;
  }
}
